var _circle, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F98600"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90261 4.5H11.1226L10.7476 11.52H9.26261L8.90261 4.5ZM10.0126 15.105C9.66261 15.105 9.37261 14.995 9.14261 14.775C8.91261 14.545 8.79761 14.265 8.79761 13.935C8.79761 13.605 8.91261 13.33 9.14261 13.11C9.37261 12.89 9.66261 12.78 10.0126 12.78C10.3526 12.78 10.6326 12.89 10.8526 13.11C11.0826 13.33 11.1976 13.605 11.1976 13.935C11.1976 14.265 11.0826 14.545 10.8526 14.775C10.6326 14.995 10.3526 15.105 10.0126 15.105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.27ecb48c4081f3f384a86eb6272807df.svg";
export { ForwardRef as ReactComponent };